<template>
  <HeroImageOverlay class="md:min-h-screen">
    <h1
      class="
        mt-28
        text-4xl
        tracking-tight
        font-extrabold
        text-white
        sm:text-5xl
        md:text-6xl
        lg:text-5xl
        xl:text-6xl
        text-center
        lg:text-left
      "
    >
      <span class="block xl:inline">H.E.L.P.M.E.</span>
    </h1>
    <p
      class="
        mt-3
        max-w-sm
        mx-auto
        lg:ml-0
        text-center
        lg:text-left
        text-lg text-gray-300
        sm:text-xl
        md:mt-5 md:max-w-3xl
      "
    >
      An innovative 6-step safety protection and injury-prevention approach that
      accords with key areas of ISO 45001 standards.
    </p>
	<img src="@/assets/media/Presenter.png" alt="" class="mt-4" style=" height: 350px;width:350px" />
  </HeroImageOverlay>

  <!-- What is H.E.L.P.M.E? -->
  <Split
    breakpoint="lg"
    title="What is H.E.L.P.M.E.?"
    description="
    <p class='my-auto'>
      H.E.L.P.M.E. represents an innovative 6-step safety protection and
      injury-prevention approach that accords with key areas of ISO 45001
      standards. Its design allows it to be self-evaluating, customizable and
      suited for a wide range of workers, workplace environments, job duties and
      organizations. It makes required safety procedures easy-to-remember and
      simple-to-remember thus easy to consistently execute/comply with.
    </p>
    "
  >
    <img src="@/assets/media/TruPath-5.jpg" alt="" />
  </Split>
  <Split
    :flip="true"
    breakpoint="lg"
    title=""
    description="
    <p>
      The steps found under each of the letters in the trademark acronym H.E.L.P.M.E., allows for its easy and effective use as…
    </p>

    <ul>
      <li>A safe work practice (SWP) & safe operating procedures (SOP) tool</li>
      <li>A risk assessment tool</li>
      <li>A return to work program</li>
      <li>An effective competency and awareness tool (i.e. training, safety talks)
      </li>
      <li>An incident/near-miss reporting tool</li>
      <li>A sustainable and effective OHS tool for worker-safety and organizations’ safety culture
      </li>
    </ul>"
  >
    <img src="@/assets/media/TruPath-8.jpg" alt="" />
  </Split>

  <!-- What Makes H.E.L.P.M.E. helpful -->
  <Split
    breakpoint="lg"
    title="What makes H.E.L.P.M.E. helpful to workers & organizations?"
    :description="helpful1"
  >
    <img src="@/assets/media/TruPath-3.jpg" alt="" />
  </Split>

  <Split
    :flip="true"
    breakpoint="lg"
    title=""
    description="
    <div class='space-y-4'>
      <div>
        <b>To concisely but thoroughly investigate incidents such as:</b>
        <ul>
          <li>Close call/near-miss reporting</li>
        </ul>
      </div>

      <div>
        <b
          >To more comprehensively conduct risk assessments to address safety
          areas such as:</b
        >
        <ul>
          <li>Workstations/sites, individual tasks</li>
          <li>Working alone</li>
          <li>Working in confined spaces</li>
        </ul>
      </div>
      
      <div>
        <b>To provide an organized documentation approach for:</b>
        <ul>
          <li>Incident reporting</li>
          <li>Daily note-taking</li>
        </ul>
      </div>
    </div>"
  >
    <img src="@/assets/media/TruPath-7.jpg" alt="" />
  </Split>

  <Split breakpoint="lg" title="" :description="helpful2">
    <img src="@/assets/media/TruPath-9.jpg" alt="" />
  </Split>

  <!-- What Makes H.E.L.P.M.E. helpful -->
  <FadingImageStats
    title=""
    description="How important are safe-work environments and working safely? These
      unfortunate statistics prove that they absolutely are:"
    :metrics="unfortunateStats"
  />

  <!-- how H.E.L.P.M.E. helps you -->
  <Split
    title="How H.E.L.P.M.E. helps you?"
    :description="howHelpDescription"
    breakpoint="lg"
  >
    <img src="@/assets/media/TruPath-1.jpg" alt="" />
  </Split>

  <Split
    title=""
    :description="howHelpDescription2"
    breakpoint="lg"
    :flip="true"
  >
    <img src="@/assets/media/TruPath-10.jpg" alt="" />
  </Split>
  
  
  <Split
    title=""
    :description="howHelpDescription3"
    breakpoint="lg"
    :flip="false"
  >
    <img src="@/assets/media/TruPath-11.jpg" alt="" />
  </Split>

  <!-- About the Founder -->
  <Container class="bg-accent-lightest">
    <h2 class="text-center text-accent">About the Founder</h2>
    <p>
      The blend of her clinical experience, OHS knowledge and faith has led her
      to being the founder of H.E.L.P.M.E.,
      <b
        >From Best-Practices to “Must-Practice”, An Innovative Solution To
        Improving Workplace Safety.</b
      >
      Lisa May Campbell holds a Masters in Occupational Therapy from the
      University of Toronto, a post-degree diploma in Occupational Health and
      Safety Management from Western University, along with complementary
      accreditations including Ergonomic Evaluations, Cognitive Functional
      Workplace Evaluation, Goal Management Training (GMT), and Cognitive
      Behavioural Therapy, which have all served her nearly 20-year career and
      professional accomplishments thus far. This includes:
    </p>

    <ul>
      <li>
        Her creation of H.E.L.P.M.E.: a sustainable, transferable and effective
        6-step occupational health and safety solution to proactively address,
        improve and maintain better occupational safety, health and longevity
        for workers and organizations globally.
      </li>
      <li>
        Being a chosen presenter of H.E.L.P.M.E. at the XXII World Congress on
        Safety and Health at Work
      </li>
      <li>
        Performing co-presentation seminars on injury prevention and reduction
        methods (against MSDs and other health risks) to front-line healthcare
        workers and key stakeholders, such as March of Dimes Canada.
      </li>
      <li>
        Since 2013, being a certified partner with the University of Toronto’s
        Quality Fieldwork Placement program and a multiple-invitee panel
        presenter to graduate students
      </li>
      <li>
        Having ran a successful private Occupational Therapy practice of over 25
        staff
      </li>
    </ul>
  </Container>

  <!-- Why H.E.L.P.M.E. was created -->
  <Split
    title="Why H.E.L.P.M.E. was created?"
    description="
    <p>Some workplace hazards and risks may be inevitable but many injuries and deaths are not. The need for at-work safety persists. The creation of H.E.L.P.M.E. is…</p>
    <ul>
      <li>To help workers EASILY remember safety protocols when participating in any line of work that involves risks…</li>
      <li>To better decrease the risk of injury/close call that a worker can, may or will face on the job.</li>
      <li>It enables workers to easily STAY aware of and consistently practice at-work and on-the-job safety.</li>
    </ul>
    <br />
    <p><b>H.E.L.P.M.E. Is not creating an OHS need; rather, tailored to fill an ongoing OHS need.</b></p>
    "
  >
    <img src="@/assets/media/TruPath-6.jpg" alt="" />
  </Split>

  <div class="order-1"></div>
</template>

<script>
import HeroImageOverlay from "../../components/layouts/hero/HeroImageOverlay.vue";
import FadingImageStats from "../../components/layouts/stats/FadingImageStats.vue";
import Split from "../../components/layouts/Split.vue";
import HeroImageSplit from "../../components/layouts/hero/HeroImageSplit.vue";
import Container from "@/components/base/Container";
import Header from "@/components/base/Header";
import * as data from "@/data";

const unfortunateStats = [
  {
    id: 1,
    stat: "New Workers",
    emphasis: "3X",
    rest: "More likely to be injured during first month of job",
  },
  {
    id: 2,
    stat: "Young Workers",
    emphasis: "30 fatalities",
    rest: "in Ontario, Canada, from 2012-2016",
  },
  {
    id: 3,
    stat: "Nurses/Personal Care Workers",
    emphasis: "200,000",
    rest: "work-related injuries annually in the United States",
  },
  {
    id: 4,
    stat: "Construction Workers",
    emphasis: "1,061",
    rest: "fatalities in the United States in 2019",
  },
  {
    id: 5,
    stat: "Forklift Operators",
    emphasis: "85,000 deaths and 34,900 serious injuries",
    rest: "annually in the United States",
  },
  {
    id: 6,
    stat: "Industrial Technicians",
    emphasis: "3000+",
    rest: "injuries during LOTO maintenance/cleaning duty",
  },
];

const helpful1 = `
    <p class="md:my-6">
      In order to help workers and organizations proactively mitigate and/or
      prevent these risks, the letters of H.E.L.P.M.E. arranges (like a wallet)
      the necessary safety steps of tasks. This makes it effectively useable for
      workers and organizations in the following ways:
    </p>
    <div class="mt-2 space-y-2">
      <div>
        <b
          >As a “Safety Wallet” by organizing those necessary safety steps and
          prompting workers to do them while performing tasks such as:</b
        >
        <ul>
          <li>Executing LOTO</li>
          <li>Operating a forklift or crane</li>
          <li>Performing manual lifting, handling or transfer activities</li>
        </ul>
      </div>
    </div>
`;

const helpful2 = `
    <div class="space-y-2 md:my-6">
      <div>
        <b
          >As a safety training and orientation guide for New and/or Young
          Workers to:</b
        >
        <ul>
          <li>Transfer taught SOPs & SWPs,</li>
          <li>Establish a Personal Accountability & Responsibility Commitment
            (PARC) to safe-work “must practices”
          </li>
          <li>Instill and maintain ergonomic and environmental awareness</li>
          <li>Maintain safety-mindfulness</li>
          <li>Greatly reduce and/or eliminate risks, accidents and injuries</li>
          <li>Continue and improve their productivity</li>
          <li>Facilitate safe-work concerns and feedback reporting</li>
        </ul>
      </div>


      <div>
        <b>For supervisors/managers to give organized and time-efficient safety meetings, talks or orientation</b>
      </div>

      <div>
        <b>Better reduce the risks and liability exposures to the organizations</b>
      </div>
    </div>
`;

const howHelpDescription = `
    <div class="mb-4">
      <h2 class="text-xl mb-2">
        A summary illustration of how H.E.L.P.M.E. helps you.
      </h2>
      <a
        href="https://vimeo.com/manage/videos/609914736"
        target="_blank"
        class="block text-accent with-underline"
        >Learn More &rarr;</a
      >
    </div>
      <h2 class="text-xl mb-2">Advantages</h2>
      <ul>
        <li>
          A very budget-overly-friendly and affordable innovative OHS
          improvement program
        </li>
        <li>
          Provides a revolutionary way for all past and ongoing OHS training
          procedures easily transferrable & sustainable for young, new and
          seasoned workers
        </li>
        <li>
          Enable workers to consistently execute correct procedures organized
          within its simple, easy-to-remember 6-step protocol to
          maintain/improve their safety during their tasks.
        </li>
        <li>
          Greatly reduce incidents of MSDs or critical, medical & first aid
          injuries
        </li>
        <li>
          Make orientation, safety talks and incident investigations more
          transferable and effective
        </li>
        <li>
          Support organizations’ efforts or commitment to keeping workers safe
          at work as reasonably possible
        </li>
      </ul>
`;

const howHelpDescription2 = `
<h2 class="text-xl mb-2 mt-2">Benefits</h2>
      <ul>
        <li>↑ health, safety and wellbeing of your staff</li>
        <li>↑ OHS accountability among workers</li>
        <li>↑ productivity</li>
        <li>↑ return on OHS investment</li>
        <li>↑ safety culture</li>
        <li>↑ staff morale</li>
        <li>↓ liability exposures to organizations</li>
        <li>↓ staff turnover</li>
        <li>↓ training and administrative costs</li>
        <li>↓ absenteeism, complaints</li>
      </ul>
`;

const howHelpDescription3 = `
	  <h2 class="text-xl mb-2 md:mt-12">For Workers, enjoy the benefit of</h2>
      <ul>
        <li>“H.E.L.P.M.E.”… to stay safe</li>
        <li>“H.E.L.P.M.E.”… to be your co-workers’ keeper</li>
        <li>“H.E.L.P.M.E.”… to not get hurt on the job</li>
        <li>“H.E.L.P.M.E.”… for safety to be everyone’s responsibility</li>
        <li>For “H.E.L.P.M.E.”… to help you</li>
      </ul>
`;
export default {
  components: {
    Container,
    Header,
    HeroImageSplit,
    Split,
    FadingImageStats,
    HeroImageOverlay,
  },
  setup() {
    return {
      data,
      unfortunateStats,
      howHelpDescription,
      howHelpDescription2,
      howHelpDescription3,
      helpful1,
      helpful2,
    };
  },
};
</script>
